/*
 * Assessments on a curriculum. Stored on the collection document:
 *
 *   preTest:  { questions: [...] }
 *   postTest: { sameAsPre: true } | { questions: [...] }
 *
 * A question: { id, stem, options: [{ id, text }], answer: optionId, explanation }
 * Single best answer, two to five options, explanation shown after answering.
 */

export const newId = () => Math.random().toString(36).slice(2, 10);

export const emptyQuestion = () => ({
  id: newId(),
  stem: '',
  options: [{ id: newId(), text: '' }, { id: newId(), text: '' }, { id: newId(), text: '' }, { id: newId(), text: '' }],
  answer: null,
  explanation: '',
});

/** The questions a test actually asks (post-test may reuse the pre-test's) */
export const questionsFor = (col, which) => {
  if (!col) return [];
  if (which === 'post' && col.postTest && col.postTest.sameAsPre) return (col.preTest && col.preTest.questions) || [];
  const test = which === 'pre' ? col.preTest : col.postTest;
  return (test && test.questions) || [];
};

export const hasTest = (col, which) => questionsFor(col, which).length > 0;

/** True when every question has a stem, two or more filled options and a chosen answer */
export const questionComplete = (q) => {
  const opts = (q.options || []).filter((o) => o.text && o.text.trim());
  return Boolean(q.stem && q.stem.trim() && opts.length >= 2 && q.answer && opts.some((o) => o.id === q.answer));
};

export const scoreAnswers = (questions, answers) => {
  const total = questions.length;
  const score = questions.filter((q) => answers[q.id] && answers[q.id] === q.answer).length;
  return { score, total };
};

export const TEST_LABEL = { pre: 'Pre-test', post: 'Post-test' };
